enum PaymentResult {
  SUCCESS = "success",
  FAILURE = "failed",
  DEFERRED = "deferred",
}

export enum PaymentResultFailureOrigin {
  Init = "PAYMENT_INIT",
  Confirmation = "PAYMENT_CONFIRMATION",
}

export enum PaymentResultFailureType {
  NotFound = "CHARGE_ORDER_NOT_FOUND",
  Canceled = "CHARGE_ORDER_CANCELED",
  AlreadyConfirmed = "CHARGE_ORDER_ALREADY_CONFIRMED",
  CanceledByCustomer = "PAYMENT_CANCELED_BY_CUSTOMER",
  Denied = "PAYMENT_DENIED",
  Expired = "PAYMENT_CONFIRMATION_TIMEFRAME_EXPIRED",
  Other = "GENERAL_FAILURE",
}

export default PaymentResult;
